export default function reducer(state={
    list:[],
    activityReivews:[],
    
},action){
switch(action.type){
    case "STORE_REVIEWS":{
        return{...state,list:action.list}
    }
    case "STORE_ACTIVITY_REVIEWS":{
        return{...state,activityReivews:action.list}
    }    
    case "LOCK_ACTIVE_BOOKING":{
        return{...state,
                    activeBooking:{                                    
                                    updated:false,
                                   }
              }
    }    
    case "LOADIND_END":{ 
        return{...state,loading:false}
    }
    case "UPDATE_TOUR":{
        return {...state,activeTour:action.tour}
    }    
}
return state
}